




























import { Component, Vue, Watch } from 'vue-property-decorator';
import classList from "./classList.vue"
import { TbGoodsClass } from '@/http';
import dayjs from "dayjs";
@Component({
    components: {
        classList
    },
})
export default class selectClassPanel extends Vue {
    public $refs: {
    };

    show = false;

    list = [];

    activeId = "";
    created() {
    }
    mounted() {
    }

    showFun(id){
        this.show = true;
        this.activeId = id;
        this.init();
    }
    closeFun(){
        this.show = false;
    }

    async init(){
        let res = await TbGoodsClass.GetAllGoodsClassList({
            needGoodsCount:false
        }) 
        this.list = res;
    }

    chooseFun(item){
        this.$emit('chooseFun',item);
        this.show = false;
    }

    addClass(type){
        this.$emit('addClass',type);
    }
    addSecondClass(item){
        let form = Object.assign({},item,{
            sort:0
        })
        this.$emit('addSecondClass',form)
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/selectClassPanel.vue